import React, { useState, useEffect } from "react";
import Loading from "./Loading";
import TodoList from "./TodoList";

function Todo() {
  const [title, setTitle] = useState('');
  const [description, setDesc] = useState('');
  const [todos, setTodos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [getError, setGetError] = useState('');

  const apiurl = 'https://sk-todo-backend.netlify.app';

  useEffect(() => {
    fetchTodos();
  }, []);

  const fetchTodos = async () => {
    try {
      const response = await fetch(apiurl + '/todos');
      const data = await response.json();
      setTodos(data);
      setLoading(false);
      setGetError('');
    } catch (e) {
      setGetError('Cannot fetch items!');
      setLoading(false);
    }
  };

  async function addTodo() {
    setError('');
    try {
      const response = await fetch(apiurl + '/todos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ title, description })
      });
      const newTodo = await response.json();
      setTitle('');
      setDesc('');
      setTodos([...todos, newTodo]);
      setMessage('Item added Successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      setError('Cannot create Item!');
    }
  }

  const handleCreate = () => {
    if (title.trim() !== '' && description.trim() !== '') {
      addTodo();
    } else {
      setError('Values should not be empty')
      setTimeout(()=>setError(''),3000)
    }
  };

  async function updateTodo(id, newTitle, newDesc) {
    try {
      await fetch(apiurl + `/todos/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ title: newTitle, description: newDesc }),
      });
      const updatedTodos = todos.map((item) =>{
        if(item._id === id) {
          item.title = newTitle;
          item.description = newDesc;
        }
        return item;
      })
      setTodos(updatedTodos);
      setMessage('Item Updated Successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      setError('Cannot update item!');
    }
  }

  async function deleteTodo(id) {
    try {
      await fetch(apiurl + `/todos/${id}`, {
        method: "DELETE",
      });
      const updatedTodos = todos.filter((item)=> item._id !== id)
      setTodos(updatedTodos);
      setMessage('Item Deleted Successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      setError('Cannot delete item!');
    }
  }

  return (
    <div className="col-12 col-md-8 gx-0 mx-auto bg-light">
      <div className="row gx-0 bg-success text-light p-2 text-center">
        <h1>Todo List</h1>
      </div>

      <div className="row gx-0 p-2">
        <h3>Add Item</h3>
        {message && <p className="text-success">{message}</p>}
        <div className="form-group d-flex flex-column flex-sm-row gap-2 my-2">
          <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="form-control"
          />
          <input
            type="text"
            placeholder="Description"
            value={description}
            onChange={(e) => setDesc(e.target.value)}
            className="form-control"
          />
          <button
            type="submit"
            onClick={(e) => handleCreate(e)}
            className="btn btn-primary"
          >
            Submit
          </button>
        </div>
        {error && <p className="text-danger">{error}</p>}
      </div>

      <div className="row gx-0 p-2">
        <h3>Tasks</h3>
        {loading ? (
          <Loading />
        ) : (
          <ul className="list-group my-2">
              <TodoList
                todos={todos}
                updateTodo={updateTodo}
                deleteTodo={deleteTodo}
                getError={getError}
              />
          </ul>
        )}
      </div>
    </div>
  );
}

export default Todo;
